<nz-sider
  nzWidth="270px"
  [nzBreakpoint]="'lg'"
  [nzCollapsed]="isCollapsed"
  [nzCollapsedWidth]="0"
  nzCollapsible>
  <div class="sidebar-header"></div>
  <div class="logo">
    <a routerLink="/dashboard"
      ><img
        [src]="orgData?.logoUrl"
        alt="logo"
        *ngIf="orgData?.logoUrl; else noOrgLogoTpl" />
      <ng-template #noOrgLogoTpl>
        <img src="/assets/images/logo.png" alt="logo" /> </ng-template
    ></a>
    <button
      nz-button
      nzType="text"
      class="close-btn"
      (click)="closeSidebar()"
      (keydown.enter)="closeSidebar()"
      tabindex="0">
      <svg-icon
        src="/assets/icon/icon-close.svg"
        class="icon s-16"
        aria-label="Close"></svg-icon>
    </button>
    <div *ngIf="environmentInfo.isActive" class="env-badge">
      {{ environmentInfo.label }}
    </div>
  </div>
  <div class="sidebar-menu-block display-flex">
    <ul nz-menu nzMode="inline" class="sidebar-menu">
      @for (item of filterMenu; track item) {
        <li
          *ngIf="!!item.children && item?.children?.length === 0"
          class="text s-16 fw-600 display-flex"
          nz-menu-item
          [routerLink]="item.route"
          routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: true }"
          tabindex="0"
          (keydown.enter)="navigateTo(item.route)">
          <svg-icon
            [src]="item.svg"
            class="icon s-12"
            aria-label="Menu Icon"></svg-icon>
          <span>{{ item.title }}</span>
        </li>
        <li
          *ngIf="item.children.length > 0"
          class="text s-16 fw-600"
          nz-submenu
          [nzOpen]="isSubmenuOpen(item)">
          <span title class="display-flex submenu-title">
            <svg-icon
              [src]="item.svg"
              class="icon s-12"
              aria-label="Menu Icon"></svg-icon>
            {{ item.title }}</span
          >
          <ul>
            @for (child of item.children; track child) {
              <li
                nz-menu-item
                class="text s-16 fw-500"
                [routerLink]="child.route"
                routerLinkActive="ant-menu-item-selected"
                [routerLinkActiveOptions]="{ exact: false }"
                tabindex="0"
                (keydown.enter)="navigateTo(child.route)">
                {{ child.title }}
              </li>
            }
          </ul>
        </li>
      }
    </ul>
    <div>
      <ul nz-menu nzMode="inline" class="sidebar-menu sidebar-menu-bottom">
        <li
          *ngIf="isSupport"
          class="text s-16 fw-600 display-flex"
          nz-menu-item
          routerLink="/support"
          routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }"
          tabindex="0"
          (keydown.enter)="navigateTo('/support')">
          <svg-icon
            src="/assets/icon/support-ico.svg"
            class="icon s-12"
            aria-label="Support Icon"></svg-icon>
          <span>Support</span>
        </li>
        <ng-container>
          <li
            *ngIf="isSupportLogin"
            class="text s-16 fw-600 display-flex"
            nz-menu-item
            routerLink="/support-login"
            routerLinkActive="ant-menu-item-selected"
            [routerLinkActiveOptions]="{ exact: false }"
            tabindex="0"
            (keydown.enter)="navigateTo('/support-login')">
            <svg-icon
              src="/assets/icon/switch-user-ico.svg"
              class="icon s-12"
              aria-label="Switch User Icon"></svg-icon>
            <span>Support Login</span>
          </li>
        </ng-container>
        <li
          (click)="showLogoutModal()"
          (keyup.enter)="showLogoutModal()"
          (keydown.enter)="showLogoutModal()"
          class="text s-16 fw-600 display-flex"
          nz-menu-item
          tabindex="0">
          <svg-icon
            src="/assets/icon/logout-ico.svg"
            class="icon s-12"
            aria-label="Logout Icon"></svg-icon>
          <span>Logout</span>
        </li>
      </ul>
      <ul nz-menu nzMode="inline" class="sidebar-menu">
        <li
          class="text s-16 fw-600 display-flex profile"
          nz-menu-item
          routerLink="/profile"
          routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }"
          tabindex="0"
          (keydown.enter)="navigateTo('/profile')">
          <div class="user-info-card display-flex">
            <div class="avatar">
              <img
                [src]="
                  userData?.profileImage
                    ? userData?.profileImage
                    : '/assets/icon/icon-student-avatar.svg'
                "
                alt="user-avatar" />
            </div>
            <div class="user-info text s-14">
              <div class="user-name fw-600" [title]="userData?.fullName">
                {{ userData?.fullName }}
              </div>
              <div
                *ngIf="userData?.isSuperAdmin"
                class="user-designation fw-400"
                [title]="!!orgData ? orgData.organizationName : ''">
                {{ !!orgData ? orgData.organizationName : '' }}
              </div>
            </div>
            <button
              nz-button
              nzType="text"
              class="notification"
              [ngClass]="{ 'notification-pulse': isNewNotification }"
              routerLink="/notifications"
              (click)="$event.stopPropagation(); resetNotificationAnimation()">
              <div
                class="notification-count fw-400"
                *ngIf="unreadNotificationCount > 0">
                {{ formatNotificationCount(unreadNotificationCount) }}
              </div>
              <svg-icon
                src="/assets/icon/icon-notification-gray.svg"
                class="icon s-24"
                aria-label="Notification Gray"></svg-icon>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nz-sider>
<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleCancel()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-red">
        <svg-icon
          src="/assets/icon/icon-logout.svg"
          class="icon s-20"
          aria-label="Logout"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Logout</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Are you sure you want to logout?
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
    <div style="display: none">
      <iframe
        class="iframe"
        id="lms_iframe"
        [src]="iframeSrc"
        width="100%"
        title="Learning Management System"
        style="border: none"></iframe>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleCancel()">
        Cancel
      </button>
      <button
        type="button"
        nz-button
        [nzType]="'primary'"
        class="btn btn-cancel"
        [nzLoading]="loading"
        (click)="onLogout()">
        Logout
      </button>
    </div>
  </ng-template>
</nz-modal>

<!-- NOSONAR -->
<button
  type="button"
  class="sidebar-overlay"
  [ngClass]="{ show: !isCollapsed }"
  (click)="closeSidebar()"
  (touchstart)="closeSidebar()"
  aria-label="Close sidebar"></button>
